module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"phone-type":"Tipo de telefone","phone-type-mobile":"Celular","phone-type-fixed":"Fixo"},"en-US":{"phone-type":"Phone Type","phone-type-mobile":"Mobile","phone-type-fixed":"Fixed line"}}')
  delete Component.options._Ctor
}
